<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="任务ID">
                  <!-- <el-input style="width: 200px;" v-model="queryForm.fansId"></el-input> -->
                  <GridSelectU title="选择任务" style="width: 200px;" labelName="taskName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择任务' @getValue="getSeachValueFANS" :columns="TASKFANS_code" :searchs="TASKFANS_search" dataListUrl="/mcn/fans/findList" entityBeanName="mcnFans" queryEntityUrl="/mcn/fans/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="用户">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="接单状态">
                  <!-- <el-input style="width: 200px;" v-model="queryForm.status"></el-input> -->
                  <el-select
                    size="small"
                    style="width: 200px;"
                    v-model="queryForm.status"
                  >
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="原因">
                  <el-input style="width: 200px;" v-model="queryForm.reason"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMcnTaskFansRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMcnTaskFansRecord"
        >新建</el-button> -->
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMcnTaskFansRecord(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMcnTaskFansRecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMcnTaskFansRecordList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMcnTaskFansRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mcnTaskFansRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fansId"
        label="任务"
        width="180"
      >
        <template slot-scope='scope'>
            <div v-if="scope.row.fans">
              {{ scope.row.fans.taskName }}
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
        <template slot-scope='scope'>
            <div v-if="scope.row.user">
              <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
              <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
              <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
              <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="接单状态"
        width="180"
      >
        <template slot-scope='scope'>
            {{ statusListItem(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="reason"
        label="原因"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMcnTaskFansRecord(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMcnTaskFansRecord(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMcnTaskFansRecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mcnTaskFansRecordStates[mcnTaskFansRecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mcnTaskFansRecord"
          ref="mcnTaskFansRecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="任务"
            prop="fansId"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFansRecord.fansId"
              :disabled="mcnTaskFansRecordState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="taskName" :disabled="mcnTaskFansRecordState == 'check'"
              labelValue="id" title="选择任务" :value="mcnTaskFansRecord.fansId" :limit='1' size='small' placeholder='请选择任务'
              @getValue="getValueFANS" :columns="TASKFANS_code" :searchs="TASKFANS_search" dataListUrl="/mcn/fans/findList" entityBeanName="mcnTaskFans" queryEntityUrl="/mcn/fans/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="mcnTaskFansRecord.userId"
              :disabled="mcnTaskFansRecordState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 200px;" labelName="userName" :disabled="mcnTaskFansRecordState == 'check'"
              labelValue="id" title="选择用户" :value="mcnTaskFansRecord.userId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="接单状态"
            prop="status"
          >
            <!-- <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFansRecord.status"
              :disabled="mcnTaskFansRecordState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFansRecord.status"
              :disabled="mcnTaskFansRecordState == 'check'"
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="原因"
            prop="reason"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mcnTaskFansRecord.reason"
              :disabled="mcnTaskFansRecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mcnTaskFansRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER,USER_SEARCH,TASKFANS,TASKFANS_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMcnTaskFansRecordList();
                    this.getMcnTaskFansRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMcnTaskFansRecordList();
                    this.getMcnTaskFansRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     fansId: '', //任务ID
                     userId: '', //用户
                     status: '', //接单状态
                     reason: '', //原因
                },
                TASKFANS_code: TASKFANS,
                TASKFANS_search: TASKFANS_SEARCH,
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mcnTaskFansRecordState: 'add',
                mcnTaskFansRecordStates: {
                    add: '新建任务',
                    check: '查看任务',
                    edit: '修改任务'
                },

                multipleSelection: [],
                mcnTaskFansRecordList: [],
                mcnTaskFansRecord: {
                    id: '', //ID
                    fansId: '', //任务ID
                    userId: '', //用户
                    status: '', //接单状态
                    reason: '', //原因
                },
                btnLoading: false,
                statusList: [],
                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    fansId: [{ required: true, message: '任务ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '接单状态不能为空', trigger: 'blur' }],
                    reason: [{ required: true, message: '原因不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMcnTaskFansRecordList();
            this.getstatusList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getstatusList(){
              get(`/mpp/utils/getEnum`,{enumType: 'mcn_signup_status'}).then((res)=>{
                this.statusList = res.enumList
              })
            },
            statusListItem(keys){
              for (let index = 0; index < this.statusList.length; index++) {
                if(this.statusList[index].key == keys){
                  return this.statusList[index].value
                }
              }
            },
            // 搜索用户
            getSeachValueUser(value){
              this.queryForm.userId = value
            },
            getSeachValueFANS(value){
              this.queryForm.fansId = value
            },
            getValueUser(value) {
              this.mcnTaskFansRecord.userId = value
            },
            getValueFANS(value) {
              console.log(value);
              this.mcnTaskFansRecord.fansId = value
            },
            resetMcnTaskFansRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mcnTaskFansRecordList = [];
            },
            resetDialog() {
                this.mcnTaskFansRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      fansId: '', //任务ID
                      userId: '', //用户
                      status: '', //接单状态
                      reason: '', //原因
                };
                this.getMcnTaskFansRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.mcnTaskFansRecord = {
                      id: '', //ID
                      fansId: '', //任务ID
                      userId: '', //用户
                      status: '', //接单状态
                      reason: '', //原因
                };
            },
            submitForm() {
                if (this.mcnTaskFansRecordState == 'add') {
                    this.$refs.mcnTaskFansRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mcn/fansrecord/add`,{ ...this.mcnTaskFansRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMcnTaskFansRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mcnTaskFansRecordState == 'edit') {
                    this.$refs.mcnTaskFansRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mcnTaskFansRecord.fans
                            delete this.mcnTaskFansRecord.user
                            post(`/mcn/fansrecord/edit`,{ ...this.mcnTaskFansRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMcnTaskFansRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMcnTaskFansRecord() {
                this.showDialog = true;
                this.mcnTaskFansRecordState = 'add';
            },
            checkMcnTaskFansRecord(mcnTaskFansRecordId) {
                console.log(mcnTaskFansRecordId);
                this.currentMcnTaskFansRecordId = mcnTaskFansRecordId;

                this.getMcnTaskFansRecordById();
                this.showDialog = true;
                this.mcnTaskFansRecordState = 'check';
            },
            editMcnTaskFansRecord(mcnTaskFansRecordId) {
                console.log('mcnTaskFansRecord', mcnTaskFansRecordId);
                if (mcnTaskFansRecordId) {
                    this.currentMcnTaskFansRecordId = mcnTaskFansRecordId;
                    this.getMcnTaskFansRecordById();
                } else {
                    this.mcnTaskFansRecord = { ...this.mcnTaskFansRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mcnTaskFansRecordState = 'edit';
            },
            deleteMcnTaskFansRecord(mcnTaskFansRecordId) {
                let ids = '';
                if (mcnTaskFansRecordId) {
                    ids = mcnTaskFansRecordId;
                } else {
                    ids = this.multipleSelection.map((mcnTaskFansRecord) => mcnTaskFansRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mcn/fansrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMcnTaskFansRecordList();
                                this.getMcnTaskFansRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMcnTaskFansRecordList() {
                this.resetMcnTaskFansRecordList();
                this.getMcnTaskFansRecordList();
            },
            getMcnTaskFansRecordList(query = {}) {
                this.loading = true;
                get(`/mcn/fansrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mcnTaskFansRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMcnTaskFansRecordById() {
                get(`/mcn/fansrecord/get`,{ id: this.currentMcnTaskFansRecordId }).then((res) =>{
                    if(res.success){
                      this.mcnTaskFansRecord = { ...this.mcnTaskFansRecord, ...res.mcnTaskFansRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMcnTaskFansRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/mcn/fansrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mcn/fansrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mcn/fansrecord/importData`,formData);
              this.refreshMcnTaskFansRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMcnTaskFansRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMcnTaskFansRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>